import { useState, useEffect } from "react";
import api from "../../services/api";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import EditModal from "../ui/EditModal.js";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquarePlus, faSquareMinus, faPencil, faLock, faLockOpen } from '@fortawesome/free-solid-svg-icons';

const AddEstadosPorPatologia = () => {
  const [EstadosPorPatologia, setEstadosPorPatologia] = useState([]);
  const [Patologias, setPatologias] = useState([]);
  const [IdPatologia, setIdPatologia] = useState("");
  const [Estados, setEstados] = useState([]);
  const [IdEstado, setIdEstado] = useState("");
  const [editandoRelacion, setEditandoRelacion] = useState(null);
  const [filtroEstado, setFiltroEstado] = useState("activas");

  useEffect(() => {
    getPatologias();
    getEstados();
    getEstadosPorPatologia();
  }, []);

  useEffect(() => {
    getEstadosPorPatologia();
  }, [IdPatologia]);

  const getPatologias = async () => {
    try {
      const response = await api.get(`/patologias`);
      const patologiasActivas = response.data.filter(p => p.estado === 1);
      setPatologias(patologiasActivas);
    } catch (error) {
      console.error("Error al obtener patologías:", error);
    }
  };

  const getEstados = async () => {
    try {
      const response = await api.get(`/estados`);
      const activos = response.data.filter(e => e.estado === 1);
      setEstados(activos);
    } catch (error) {
      console.error("Error al obtener estados:", error);
    }
  };

  const getEstadosPorPatologia = async () => {
    if (!IdPatologia) return;
    try {
      const response = await api.get(`/estadosporpatologia/${IdPatologia}`);
      setEstadosPorPatologia(response.data);
    } catch (error) {
      console.error("Error al obtener estados por patología:", error);
    }
  };

  const createEstadoPorPatologia = async (e) => {
    e.preventDefault();
    if (!IdPatologia || !IdEstado) {
      return Swal.fire("Falta completar", "Selecciona una patología y un estado", "warning");
    }
    const yaExiste = EstadosPorPatologia.some(item => item.IdEstado === parseInt(IdEstado));
    if (yaExiste) {
      return Swal.fire("Duplicado", "Este estado ya está asociado", "error");
    }

    try {
      await api.post(`/estadosporpatologia`, {
        IdPatologia,
        IdEstado,
      });
      Swal.fire("Éxito", "Estado asociado correctamente", "success");
      setIdEstado("");
      getEstadosPorPatologia();
    } catch (error) {
      Swal.fire("Error", "No se pudo guardar", "error");
    }
  };

  const eliminarRelacion = async (IdEstadoPorPatologia) => {
  const confirm = await Swal.fire({
    title: "¿Estás seguro?",
    text: "Esta acción desactivará la relación",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Sí, desactivar",
    cancelButtonText: "Cancelar",
  });

  if (confirm.isConfirmed) {
    try {
      await api.put(`/estadoPatologiaToggleEstado/${IdEstadoPorPatologia}`);
      Swal.fire("Eliminado", "Relación desactivada", "success");
      getEstadosPorPatologia(); // Refresca la tabla
    } catch (error) {
      Swal.fire("Error", "No se pudo eliminar", "error");
      console.error("Error al desactivar:", error.response?.data || error.message);
    }
  }
};

 const handleEditar = async (valores) => {
  try {
    await api.put(`/estadosporpatologia`, {
      IdEstadoPorPatologia: valores.IdEstadoPorPatologia,
      IdEstado: valores.IdEstado,
    });
    Swal.fire("Actualizado", "Relación actualizada correctamente", "success");
    setEditandoRelacion(null);
    getEstadosPorPatologia();
  } catch (error) {
    Swal.fire("Error", "No se pudo actualizar", "error");
    console.error("Error al editar:", error.response?.data || error.message);
  }
};

 const cambiarEstado = async (id) => {
  try {
    const response = await api.put(`/estadoPatologiaToggleEstado/${id}`);
    console.log("Estado actualizado:", response.data);
    getEstadosPorPatologia(); // <- refresca la tabla
  } catch (error) {
    console.error("Error al cambiar estado:", error);
    Swal.fire("Error", "No se pudo cambiar el estado", "error");
  }
 };

 const cambiarCondicionCierre = async (row) => {
  const quedaraCerrado = Number(row.EsCerrado) !== 1;
  const confirm = await Swal.fire({
    title: quedaraCerrado ? "¿Marcar como estado cerrado?" : "¿Marcar como estado abierto?",
    text: quedaraCerrado
      ? "Los casos con este estado se contabilizarán como cerrados para esta patología."
      : "Los casos con este estado dejarán de contabilizarse como cerrados.",
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Confirmar",
    cancelButtonText: "Cancelar",
  });

  if (!confirm.isConfirmed) return;
  try {
    await api.put(`/estadoPatologiaToggleCierre/${row.IdEstadoPorPatologia}`);
    await getEstadosPorPatologia();
  } catch (error) {
    console.error("Error al cambiar la condición de cierre:", error);
    Swal.fire("Error", "No se pudo cambiar la condición del estado", "error");
  }
 };

 const columnas = [
  {
    name: "Estado",
    selector: row => row.Nombre || "Sin nombre",
    sortable: true,
  },
  {
    name: "Color",
    selector: row => row.ColorAsociado || "-",
    cell: row => (
      <div
        style={{
          backgroundColor: row.ColorAsociado || "#fff",
          padding: "4px 8px",
          borderRadius: "4px",
          color: "#000",
        }}
      >
        {row.ColorAsociado}
      </div>
    ),
  },
  {
    name: "Condición del caso",
    cell: row => {
      const cerrado = Number(row.EsCerrado) === 1;
      return (
        <button
          type="button"
          className={`button is-small ${cerrado ? "is-danger" : "is-success is-light"}`}
          title="Cambiar condición de apertura o cierre"
          onClick={() => cambiarCondicionCierre(row)}
        >
          <span className="icon"><FontAwesomeIcon icon={cerrado ? faLock : faLockOpen} /></span>
          <span>{cerrado ? "Cerrado" : "Abierto"}</span>
        </button>
      );
    },
    ignoreRowClick: true,
    allowOverflow: true,
  },
{
  name: "Acciones",
  cell: (row) => (
    <>
      <button
        className="button is-small is-info mr-2 icon-pencil"
        title="Editar"
        onClick={() => setEditandoRelacion(row)}
      >
        <FontAwesomeIcon icon={faPencil} />
      </button>
{row.estado === 1 ? (
  <FontAwesomeIcon
    icon={faSquareMinus}
    style={{ color: "#37ff00", cursor: "pointer", marginLeft: "10px" }}
    size="2xl"
    title="Desactivar"
    onClick={() => cambiarEstado(row.IdEstadoPorPatologia)}
  />
) : (
  <FontAwesomeIcon
    icon={faSquarePlus}
    style={{ color: "#ff0000", cursor: "pointer", marginLeft: "10px" }}
    size="2xl"
    title="Activar"
    onClick={() => cambiarEstado(row.IdEstadoPorPatologia)}
  />
)}
    </>
  ),
  ignoreRowClick: true,
  allowOverflow: true,
  button: true,
  compact: true,
}
];
const filtrarPorEstado = () => {
  if (filtroEstado === "todas") return EstadosPorPatologia;
  if (filtroEstado === "activas") return EstadosPorPatologia.filter(e => e.estado === 1);
  if (filtroEstado === "inactivas") return EstadosPorPatologia.filter(e => e.estado === 0);
  return EstadosPorPatologia;
};

  const editFields = [
    {
      name: "IdEstado",
      label: "Estado",
      type: "select",
      required: true,
      options: Estados.map((e) => ({ label: e.Nombre, value: e.IdEstado })),
    }
  ];

  const paginationOptionsES = {
    rowsPerPageText: "Filas por página",
    rangeSeparatorText: "de",
    selectAllRowsItem: true,
    selectAllRowsItemText: "Todos",
  };

  return (
    <div className="columns mt-5 is-centered">
      <div className="column is-half">
        <div className="notification is-primary">
          <strong>Patologías por Estados</strong>
        </div>
        <form onSubmit={createEstadoPorPatologia}>
          <div className="field">
            <label className="label required">Seleccionar Patología</label>
            <div className="select is-fullwidth">
              <select value={IdPatologia} onChange={e => setIdPatologia(e.target.value)} required>
                <option value="">Seleccionar</option>
                {Patologias.map(p => (
                  <option key={p.IdPatologia} value={p.IdPatologia}>{p.Nombre}</option>
                ))}
              </select>
            </div>
          </div>
          <div className="field">
            <label className="label required">Estados</label>
            <div className="select is-fullwidth">
              <select value={IdEstado} onChange={e => setIdEstado(e.target.value)} required>
                <option value="">Seleccionar</option>
                {Estados.map(e => (
                  <option key={e.IdEstado} value={e.IdEstado}>{e.Nombre}</option>
                ))}
              </select>
            </div>
          </div>
          <button type="submit" className="button is-success">Guardar</button>
        </form>

        <div className="mt-4">
          <div style={{ display: 'flex', gap: '10px', marginBottom: '1rem' }}>
            {["todas", "activas", "inactivas"].map((estado) => (
              <button
                key={estado}
                onClick={() => setFiltroEstado(estado)}
                type="button"
                style={{
                  padding: "6px 16px",
                  border: "none",
                  borderRadius: "20px",
                  backgroundColor: filtroEstado === estado ? "#d1f5d3" : "#f0f2f5",
                  color: filtroEstado === estado ? "#075e54" : "#333",
                  fontWeight: filtroEstado === estado ? "bold" : "normal",
                  boxShadow: filtroEstado === estado ? "inset 0 0 0 1px #1ebea5" : "inset 0 0 0 1px #ccc",
                  cursor: "pointer",
                  transition: "all 0.2s ease-in-out",
                  fontSize: "0.9rem",
                }}
              >
                {estado.charAt(0).toUpperCase() + estado.slice(1)}
              </button>
            ))}
          </div>
          <DataTable
            pagination
            paginationComponentOptions={paginationOptionsES}
            columns={columnas}
            data={filtrarPorEstado()}
          />
        </div>

        {editandoRelacion && (
          <EditModal
            fields={editFields}
            initialValues={editandoRelacion}
            onSubmit={handleEditar}
            onClose={() => setEditandoRelacion(null)}
            title="Editar Estado por Patología"
          />
        )}
      </div>
    </div>
  );
};

export default AddEstadosPorPatologia;
